import styled from 'styled-components';

export const IngestType = styled.div``;
